import type { SelectOption } from '@civilgrid/ui/components';
import rootStore from '~/store';

export function getRoles(): SelectOption[] {
  const { currentOrganizationDetail, myRole } = rootStore;
  if (currentOrganizationDetail.isLoading) {
    return [];
  } else {
    const items: SelectOption[] = [];
    let reachedMyLevel = false;
    currentOrganizationDetail.roles.forEach((r) => {
      if (!reachedMyLevel && r.roleId === myRole!.roleId) {
        reachedMyLevel = true;
      }
      if (reachedMyLevel) {
        items.push({
          label: r.name,
          value: r.roleId,
        });
      }
    });

    return items;
  }
}

export function isRoleHigherThanMine(role: string) {
  const { currentOrganizationDetail, myRole } = rootStore;
  if (currentOrganizationDetail.isLoading) {
    return false;
  } else {
    const myRoleIndex = currentOrganizationDetail.roles.findIndex((r) => r.roleId === myRole!.id);
    const givenRoleIndex = currentOrganizationDetail.roles.findIndex((r) => r.roleId === role);

    return givenRoleIndex < myRoleIndex;
  }
}
